import { useForm } from '@/features/pos/components/ProductConfigurationModal/form'
import { ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'
import { FC, ReactNode } from 'react'
import { FormProvider } from 'react-hook-form'

interface ProviderProps {
    productVariant?: ProductVariant
    defaultQuantity?: number
    children: ReactNode
}

const Provider: FC<ProviderProps> = ({ productVariant, defaultQuantity, children }) => {
    const methods = useForm(productVariant, defaultQuantity)

    return <FormProvider {...methods}>{children}</FormProvider>
}

export default Provider
